import { connect, ConnectedProps } from "react-redux";

import { withRouter } from "react-router";
import { IStoreState } from "../../../../../../reducers/types";
import { actions } from "../../../../actions";
import {
  getFromDate,
  getUntilDate,
  getLocation,
  getAdultsCount,
  getRoomsCount,
  getChildren,
} from "../../../../reducer";
import { MobileCalendarPickerModal } from "./component";
import { getIsTravelApp } from "../../../../../availability/reducer";

const mapDispatchToProps = {
  setFromDate: actions.setFromDate,
  setUntilDate: actions.setUntilDate,
};
const mapStateToProps = (state: IStoreState) => ({
  fromDate: getFromDate(state),
  untilDate: getUntilDate(state),
  searchLocation: getLocation(state),
  adultsCount: getAdultsCount(state),
  children: getChildren(state),
  roomsCount: getRoomsCount(state),
  isTravelApp: getIsTravelApp(state),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileCalendarPickerModalConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileCalendarPickerModal = withRouter(
  connector(MobileCalendarPickerModal)
);
